<template>
  <div class="tool-detail-page white-theme pollo-layout">
    <div class="container">
      <section class="first-screen">
      <div class="breadcrumb">
        <router-link to="/">{{ $t('modelDetail.breadcrumb.home') }}</router-link>
        <span>&rsaquo;</span>
        <router-link to="/tools">{{ $t('tools.page.allTools') }}</router-link>
        <span>&rsaquo;</span>
        <span>{{ $t('tools.background-blur.name') }}</span>
      </div>

      <div class="first-screen-grid">
        <div class="action-column">
      <div v-if="!isLoggedIn" class="login-prompt">
        <div class="login-prompt-content">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" stroke-width="1"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          <h2>{{ $t('tools.detail.loginRequired') }}</h2>
          <p>{{ $t('tools.detail.loginRequiredDesc') }}</p>
          <button class="btn btn-primary" @click="goLogin">{{ $t('tools.detail.loginNow') }}</button>
        </div>
      </div>

      <div v-else class="tool-interface">
        <div
          class="tool-upload"
          @click="triggerUpload"
          @dragover.prevent
          @drop.prevent="onDrop"
        >
          <input type="file" ref="fileInput" accept="image/*" style="display:none" @change="handleFile">
          <div v-if="!uploaded" class="upload-placeholder">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" stroke-width="1"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>
            <p>{{ $t('tools.detail.clickUpload') }}{{ $t('tools.fileTypes.image') }}</p>
            <span>{{ $t('tools.detail.support') }} JPG, PNG, WebP</span>
          </div>
          <div v-else class="upload-preview">
            <div class="preview-box preview-box--image">
              <img v-if="previewSrc" :src="previewSrc" :alt="$t('tools.background-blur.name') + ' preview'" class="preview-img">
            </div>
            <button class="btn btn-secondary" @click.stop="clearUpload">{{ $t('tools.detail.reupload') }}</button>
          </div>
        </div>

        <div class="tool-options">
          <button class="btn btn-primary btn-lg" :disabled="!uploaded || processing" @click="process">
            <svg v-if="processing" class="spinner" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            <span v-else>{{ $t('tools.detail.process') }}</span>
          </button>
        </div>

        <div class="tool-result legacy-tool-result" v-if="processing || processed">
          <div v-if="processing" class="gen-loading">
            <div class="loading-spinner"></div>
            <p>{{ $t('tools.detail.processing') }}</p>
          </div>
          <div v-else class="tool-output">
            <div class="output-comparison">
              <div class="output-before">
                <span class="output-label">{{ $t('tools.detail.before') }}</span>
                <div class="output-image output-image--fill">
                  <img v-if="previewSrc" :src="previewSrc" alt="Before" class="compare-img">
                </div>
              </div>
              <div class="output-after">
                <span class="output-label">{{ $t('tools.detail.after') }}</span>
                <div class="output-image output-image--fill">
                  <img v-if="resultSrc" :src="resultSrc" alt="After" class="compare-img">
                </div>
              </div>
            </div>
            <div class="output-actions">
              <button v-if="resultSrc" type="button" class="btn btn-primary" @click="downloadResult">⬇️ {{ $t('tools.detail.download') }}</button>
              <button class="btn btn-secondary" @click="reset">{{ $t('tools.detail.processNew') }}</button>
            </div>
          </div>
        </div>

      </div>

        </div>
        <div class="showcase-column">
      <div class="tool-hero"><div class="tool-hero-info"><h1>{{ $t('tools.background-blur.name') }}</h1><p class="tool-hero-desc">{{ $t('brandSeo.toolDescription', { description: $t('tools.background-blur.fullDesc') }) }}</p></div></div>

      <!-- 效果演示 -->
      <div class="demo-section workspace-panel" v-if="!processing && !processed">
        <h2 class="demo-title">{{ $t('tools.detail.demo') }}</h2>
        <div class="demo-comparison">
          <div class="demo-item">
            <span class="demo-label">{{ $t('tools.detail.before') }}</span>
            <div class="demo-image">
              <img src="@/assets/images/background_blur1.png" alt="Before">
            </div>
          </div>
          <div class="demo-arrow">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </div>
          <div class="demo-item">
            <span class="demo-label">{{ $t('tools.detail.after') }}</span>
            <div class="demo-image">
              <img src="@/assets/images/background_blur2.png" alt="After">
            </div>
          </div>
        </div>
      </div>
      <div class="processing-panel workspace-panel" v-else-if="processing"><div class="workspace-heading"><h2>{{ $t('tools.detail.processing') }}</h2></div><div class="processing-preview"><img v-if="previewSrc" :src="previewSrc" alt="Processing preview"><div class="processing-overlay"><div class="loading-spinner"></div></div></div><div class="processing-track"><span></span></div></div>
      <div class="result-panel workspace-panel" v-else><div class="workspace-heading"><h2>{{ $t('tools.detail.after') }}</h2></div><div class="output-comparison"><div class="output-before"><span class="output-label">{{ $t('tools.detail.before') }}</span><div class="output-image output-image--fill"><img v-if="previewSrc" :src="previewSrc" alt="Before" class="compare-img"></div></div><div class="output-after"><span class="output-label">{{ $t('tools.detail.after') }}</span><div class="output-image output-image--fill"><img v-if="resultSrc" :src="resultSrc" alt="After" class="compare-img"></div></div></div><div class="output-actions"><button v-if="resultSrc" type="button" class="btn btn-primary" @click="downloadResult">{{ $t('tools.detail.download') }}</button><button class="btn btn-secondary" @click="reset">{{ $t('tools.detail.processNew') }}</button></div></div>
        </div>
      </div>
      </section>

      <div class="detail-section" style="margin-top:64px;">
        <h2>{{ $t('tools.detail.howToUse') }}</h2>
        <div class="steps">
          <div class="step" v-for="(step, idx) in steps" :key="idx">
            <div class="step-number">{{ idx + 1 }}</div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.desc }}</p>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h2>{{ $t('tools.detail.moreTools') }}</h2>
        <div class="grid-5">
          <ToolListCard
            v-for="t in otherTools"
            :key="t.id"
            :tool-id="t.id"
            :icon="t.icon"
            :badge="t.badge"
            :to="'/tools/' + t.id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { submitBgBlur, pollBgBlur } from '@/api/bgBlur'
import { saveOrUpdateAIHistory, formatCreateDate, uploadFile } from '@/api'
import { isAuthenticated } from '@/api/auth'
import ToolListCard from '@/components/ToolListCard.vue'

var BG_BLUR_MAX_BYTES = 15 * 1024 * 1024

export default {
  name: 'BackgroundBlurDetail',
  components: { ToolListCard },
  data() {
    return {
      uploaded: false,
      processing: false,
      processed: false,
      previewSrc: '',
      resultSrc: '',
      uploadedFile: null,
      processError: null,
      poller: null
    }
  },
  beforeDestroy() {
    if (this.poller) {
      this.poller.stop()
      this.poller = null
    }
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.userInfo
    },
    otherTools() {
      return this.$store.state.tools.filter(function(t) { return t.id !== 'background-blur' }).slice(0, 5)
    },
    steps() {
      return [
        { title: this.$t('tools.steps.upload.title'), desc: this.$t('tools.steps.upload.desc') },
        { title: this.$t('tools.steps.process.title'), desc: this.$t('tools.steps.process.desc') },
        { title: this.$t('tools.steps.download.title'), desc: this.$t('tools.steps.download.desc') }
      ]
    }
  },
  methods: {
    goLogin() {
      this.$store.dispatch('showLoginModal')
    },
    triggerUpload() {
      if (this.$refs.fileInput) this.$refs.fileInput.click()
    },
    onDrop(e) {
      var files = e.dataTransfer && e.dataTransfer.files
      if (files && files[0]) this.readFile(files[0])
    },
    handleFile(e) {
      var input = e.target
      var file = input.files && input.files[0]
      if (!file) {
        if (input) input.value = ''
        return
      }
      this.readFile(file)
      if (input) input.value = ''
    },
    readFile(file) {
      var self = this
      this.processError = null
      if (!file.type || file.type.indexOf('image/') !== 0) {
        this.processError = this.$t('tools.background-blur.notImageFile')
        return
      }
      if (file.size > BG_BLUR_MAX_BYTES) {
        this.processError = this.$t('tools.background-blur.fileTooLarge')
        return
      }
      var reader = new FileReader()
      reader.onload = function(ev) {
        self.previewSrc = (ev.target && ev.target.result) ? String(ev.target.result) : ''
        self.uploadedFile = file
        self.uploaded = !!self.previewSrc
        self.processed = false
        self.resultSrc = ''
      }
      reader.onerror = function() {
        self.processError = self.$t('common.generateFailedContactSupport')
      }
      reader.readAsDataURL(file)
    },
    clearUpload() {
      this.uploaded = false
      this.previewSrc = ''
      this.uploadedFile = null
      this.resultSrc = ''
      this.processed = false
      this.processing = false
      this.processError = null
    },
    reset() {
      this.clearUpload()
    },
    downloadResult() {
      if (!this.resultSrc) return
      var url = this.resultSrc
      var name = this.$t('tools.background-blur.downloadName')
      fetch(url)
        .then(function(r) { return r.blob() })
        .then(function(blob) {
          var u = URL.createObjectURL(blob)
          var a = document.createElement('a')
          a.href = u
          a.download = name
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(u)
        })
        .catch(function() {
          window.open(url, '_blank')
        })
    },
    process() {
      var self = this
      if (!this.uploadedFile) return
      this.processing = true
      this.processed = false
      this.processError = null
      var createDate = formatCreateDate(new Date())
      var aiName = this.$t('tools.background-blur.name')
      var aiDesc = this.$t('tools.background-blur.name')
      var historyId = null
      var originalUrl = ''

      // 1. 先上传原图到服务器，拿到 imageUrl
      uploadFile(this.uploadedFile).then(function(url) {
        originalUrl = url
      }).catch(function() {
        self.processing = false
        self.processError = self.$t('tools.detail.uploadOriginalFailed')
        return Promise.reject('uploadOriginalFailed')
      }).then(function() {
        // 2. 创建历史记录，带上原图 URL
        return saveOrUpdateAIHistory({
          aiName: aiName,
          taskId: '',
          aiDesc: aiDesc,
          state: 1,
          aiResultUrl: '',
          image_large_url: originalUrl,
          aiMediaType: 'image',
          createDate: createDate
        })
      }).then(function(hRes) {
        historyId = hRes && (hRes.historyId != null ? hRes.historyId : null)
      }).then(function() {
        // 3. 提交背景虚化任务
        return submitBgBlur({ imageUrl: originalUrl })
      }).then(function(res) {
        // 4. 轮询结果
        self.poller = pollBgBlur(res.promptId, function(err, imageUrl) {
          self.poller = null
          if (err) {
            self.onFailed(err, historyId, aiName, aiDesc, originalUrl, createDate)
          } else {
            self.onSuccess(imageUrl, historyId, aiName, aiDesc, originalUrl, createDate)
          }
        })
      }).catch(function(err) {
        if (err === 'uploadOriginalFailed') return
        self.processing = false
        self.processed = false
        self.resultSrc = ''
        self.processError = self.$userFacingError(err, self.$t('common.generateFailedContactSupport'))
        saveOrUpdateAIHistory({
          aiName: aiName,
          historyId: historyId,
          taskId: '',
          aiDesc: aiDesc,
          state: 3,
          message: (err && err.message) ? err.message : '',
          aiResultUrl: '',
          image_large_url: originalUrl,
          aiMediaType: 'image',
          createDate: createDate
        }).catch(function() {})
      })
    },
    onSuccess(imageUrl, historyId, aiName, aiDesc, originalUrl, createDate) {
      var self = this
      self.processing = false
      self.resultSrc = imageUrl
      self.processed = true
      self.processError = null
      // 更新历史记录为成功（结果已是 OSS URL，直接记录）
      saveOrUpdateAIHistory({
        aiName: aiName || self.$t('tools.background-blur.name'),
        historyId: historyId,
        taskId: '',
        aiDesc: aiDesc || self.$t('tools.background-blur.name'),
        state: 2,
        aiResultUrl: imageUrl || '',
        image_large_url: originalUrl || '',
        aiMediaType: 'image',
        createDate: createDate || formatCreateDate(new Date())
      }).catch(function() {})
    },
    onFailed(err, historyId, aiName, aiDesc, originalUrl, createDate) {
      this.processing = false
      this.processed = false
      this.resultSrc = ''
      this.processError = this.$userFacingError(err, this.$t('common.generateFailedContactSupport'))
      saveOrUpdateAIHistory({
        aiName: aiName || this.$t('tools.background-blur.name'),
        historyId: historyId,
        taskId: '',
        aiDesc: aiDesc || this.$t('tools.background-blur.name'),
        state: 3,
        message: (err && err.message) ? err.message : '',
        aiResultUrl: '',
        image_large_url: originalUrl || '',
        aiMediaType: 'image',
        createDate: createDate || formatCreateDate(new Date())
      }).catch(function() {})
    }
  }
}
</script>

<style scoped>
@import '../styles/toolPolloLayout.css';

@import './ModelDetailStyles.css';

.tool-detail-page { padding: 48px 0 80px; }
.breadcrumb { display: flex; align-items: center; gap: 8px; margin-bottom: 32px; font-size: 13px; color: var(--text-muted); }
.breadcrumb a { color: var(--text-secondary); }
.breadcrumb a:hover { color: var(--accent); }
.tool-hero { margin-bottom: 32px; }
.tool-hero-info { text-align: center; max-width: 640px; margin: 0 auto; }
.tool-icon-lg { font-size: 48px; display: block; margin-bottom: 16px; }
.tool-hero-info h1 { font-size: 36px; font-weight: 800; margin-bottom: 12px; }
.tool-hero-desc { font-size: 16px; color: var(--text-secondary); line-height: 1.7; margin-bottom: 24px; }
.login-prompt { background: var(--bg-card); border: 1px solid var(--bg-card-border); border-radius: var(--radius-xl); padding: 24px 28px; text-align: center; margin: 32px auto 0; max-width: 680px; }
.login-prompt-content { max-width: 360px; margin: 0 auto; }
.login-prompt-content svg { display: block; margin: 0 auto; }
.login-prompt h2 { margin: 6px 0 4px; font-size: 20px; }
.login-prompt p { color: var(--text-muted); font-size: 14px; margin-bottom: 12px; }
.tool-interface { background: var(--bg-card); border: 1px solid var(--bg-card-border); border-radius: var(--radius-xl); padding: 32px; margin: 32px auto 0; max-width: 680px; }
.tool-upload { cursor: pointer; }
.upload-placeholder { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 64px; border: 2px dashed var(--border-color); border-radius: var(--radius-lg); transition: border-color 0.2s; }
.upload-placeholder:hover { border-color: var(--accent); }
.upload-placeholder p { margin-top: 12px; font-size: 14px; color: var(--text-secondary); }
.upload-placeholder span { font-size: 12px; color: var(--text-muted); }
.upload-preview { display: flex; flex-direction: column; align-items: center; gap: 16px; max-height: none; }
.preview-box { width: 360px; max-width: 100%; aspect-ratio: 4 / 3; border-radius: var(--radius-lg); display: flex; align-items: center; justify-content: center; overflow: hidden; background: #e8e8ec; }
.preview-box--image { padding: 0; }
.preview-img { max-width: 100%; max-height: 100%; width: auto; height: auto; object-fit: contain; display: block; }
.tool-error { color: #f87171; font-size: 13px; margin: 0 0 12px; }
.tool-error--block { text-align: center; margin-bottom: 16px; }
.output-image--fill { padding: 0; overflow: hidden; background: var(--bg-primary); }
.compare-img { width: 100%; height: 100%; object-fit: contain; display: block; min-height: 200px; max-height: 420px; background: var(--bg-primary); }
.tool-options { display: flex; align-items: flex-end; gap: 16px; margin-top: 12px; justify-content: center; }
.tool-result { margin-top: 32px; }
.gen-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 200px; gap: 12px; }
.loading-spinner { width: 40px; height: 40px; border: 3px solid var(--border-color); border-top-color: var(--accent); border-radius: 50%; animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.output-comparison { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
.output-label { display: block; font-size: 12px; font-weight: 600; color: var(--text-muted); margin-bottom: 8px; text-transform: uppercase; }
.output-image { aspect-ratio: 1; border-radius: var(--radius-lg); display: flex; align-items: center; justify-content: center; }
.output-actions { display: flex; gap: 12px; justify-content: center; margin-top: 12px; }
/* 效果演示对比图 */
.demo-section { margin: 32px auto 0; padding: 24px; background: var(--bg-primary); border-radius: var(--radius-lg); max-width: 760px; }
.demo-title { font-size: 16px; font-weight: 600; text-align: center; margin-bottom: 20px; color: var(--text-primary); }
.demo-comparison { display: flex; align-items: center; justify-content: center; gap: 24px; flex-wrap: wrap; }
.demo-item { flex: 1; min-width: 200px; max-width: 300px; }
.demo-label { display: block; font-size: 12px; font-weight: 600; color: var(--text-muted); margin-bottom: 8px; text-transform: uppercase; text-align: center; }
.demo-image { aspect-ratio: 3/4; border-radius: var(--radius-lg); overflow: hidden; background: var(--bg-secondary); }
.demo-image img { width: 100%; height: 100%; object-fit: cover; }
.demo-arrow { color: var(--text-muted); flex-shrink: 0; }
.detail-section { margin-bottom: 64px; }
.detail-section h2 { font-size: 24px; font-weight: 700; margin-bottom: 24px; }
.steps { display: flex; justify-content: center; gap: 48px; flex-wrap: wrap; }
.step { text-align: center; }
.step-number { width: 40px; height: 40px; border-radius: 50%; background: var(--accent); color: #000; display: flex; align-items: center; justify-content: center; font-weight: 700; margin: 0 auto 12px; }
.step h3 { margin-bottom: 6px; }
.step p { font-size: 13px; color: var(--text-muted); }
.spinner { animation: spin 1s linear infinite; }
@media (max-width: 768px) { .steps { grid-template-columns: repeat(2, 1fr); } .output-comparison { grid-template-columns: 1fr; } }
</style>
